import * as yup from "yup";

export const technicalPackageValidation = yup.object().shape({
    name: yup.string().max(150, "Namn får max innehålla 150 tecken.").required("Namn är obligatoriskt!"),
    description: yup.string().max(250, "Beskrivningen får max innehålla 250 tecken."),

})